export default __webpack_public_path__ + "css/mdcweb.min.css";